import React from 'react';
import { Navigate } from 'react-router-dom';
import useAuthSync from '../hooks/useAuthSync';

/**
 * ProtectedRoute - Wraps routes that require authentication.
 * Optionally restricts by role(s).
 * Auto-syncs user role from backend on every mount.
 * 
 * @param {React.ReactNode} children - The component to render if authorized
 * @param {string|string[]} [allowedRoles] - Optional role(s) allowed to access this route
 */
function ProtectedRoute({ children, allowedRoles }) {
  // Sync role from backend — if admin changed it, localStorage updates & page reloads
  useAuthSync();

  const token = localStorage.getItem('token');
  const user = JSON.parse(localStorage.getItem('user') || 'null');

  // Not logged in at all
  if (!token || !user) {
    return <Navigate to="/login" replace />;
  }

  // Role restriction check
  if (allowedRoles) {
    const roles = Array.isArray(allowedRoles) ? allowedRoles : [allowedRoles];
    if (!roles.includes(user.role)) {
      // Redirect to home if user doesn't have the required role
      return <Navigate to="/" replace />;
    }
  }

  return children;
}

export default ProtectedRoute;
